import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';

import { ROUTER_LOCATION_CHANGED } from '../redux/route';
import { getCardIdFromRoute } from '../utils/selectors/singleCard';
import { CARD_PAGE } from '../../routes';

import {
  singleCardRequest,
  singleCardOriginalRequest,
} from '../redux/singleCard';

import get from 'lodash/get';
import type { ActionObs, Store, Obs } from '../types';

const cleanIdValue = value => {
  const parsedValue = parseInt(value);
  return isNaN(parsedValue) || parsedValue < 1 ? undefined : parsedValue;
};

export function singleCardRoute(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(ROUTER_LOCATION_CHANGED)
    .filter(action => {
      let newRoute = get(action, 'payload');
      if (newRoute.pathType !== CARD_PAGE) {
        return false;
      }

      let cardId = cleanIdValue(getCardIdFromRoute(get(action, 'payload')));
      let prevCardId = cleanIdValue(
        getCardIdFromRoute(get(store.getState(), 'route.previousRoute')),
      );

      let variationQuery = cleanIdValue(
        get(action, 'payload.query.variation_id'),
      );
      let prevVariationQuery = cleanIdValue(
        get(store.getState(), 'route.previousRoute.query.variation_id'),
      );

      let suiteVariationQuery = cleanIdValue(
        get(newRoute, 'query.suite_variation_id'),
      );
      let prevSuiteVariationQuery = cleanIdValue(
        get(store.getState(), 'route.previousRoute.query.suite_variation_id'),
      );

      // Brute force the differences...
      const currentId = variationQuery || suiteVariationQuery || cardId;
      const previousId =
        prevVariationQuery || prevSuiteVariationQuery || prevCardId;

      return currentId && currentId !== previousId;
    })
    .switchMap(actionProps => {
      const {
        payload,
        payload: {
          params,
          query: { variation_id, suite_variation_id },
        },
      } = actionProps;

      let queryId = getCardIdFromRoute(payload);
      let paramsId = get(params, 'id');
      let requestId = paramsId || queryId;

      return Observable.of(
        singleCardRequest(requestId, variation_id, suite_variation_id),
      );
    });
}

export function singleCardOriginalRoute(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(ROUTER_LOCATION_CHANGED)
    .filter(action => {
      let isCardRoute = get(action, 'payload.pathType', '') === CARD_PAGE;
      let cardId = getCardIdFromRoute(action.payload);
      let originalCardId = get(store.getState(), 'singleCard.originalData.id');
      let alreadyLoadedCardData = originalCardId == cardId;

      // Don't continue if we're outside card route, or the card id is not valid, or we alreay loaded this original card...
      if (
        !isCardRoute ||
        cardId < 0 ||
        isNaN(cardId) ||
        alreadyLoadedCardData
      ) {
        return false;
      }

      let queryCardVaritionId = parseInt(
        get(action, 'payload.query.variation_id', -1),
      );
      let queryCardSuiteId = parseInt(
        get(action, 'payload.query.suite_variation_id', -1),
      );

      return (
        (queryCardVaritionId >= 0 && !isNaN(queryCardVaritionId)) ||
        (queryCardSuiteId >= 0 && !isNaN(queryCardSuiteId))
      );
    })
    .switchMap(actionProps => {
      let cardId = getCardIdFromRoute(actionProps.payload);

      return Observable.of(singleCardOriginalRequest(cardId));
    });
}

export default combineEpics(singleCardRoute, singleCardOriginalRoute);
